<div class="updateOverlay" role="alert" aria-live="polite" aria-busy="true">
  <div class="updateCenter">
    <img [src]="logoSrc" alt="RET de Residus" class="updateLogo">
  </div>

  <div class="updateLoadingBar" aria-hidden="true">
    <div class="updateLoadingBarFill" [style.width.%]="progress"></div>
  </div>
</div>
